// Connexion au back-office.
//
// Volontairement différente de la connexion des clients : un bloc noir, deux
// champs, rien d'autre. On doit voir au premier regard dans quel environnement
// on entre — et ne trouver ici ni inscription, ni lien, ni texte d'accueil.
//
// C'est la MÊME authentification que le reste de l'application : ce qui réserve
// le back-office à l'exploitant est vérifié par le serveur à chaque appel, pas
// par cet écran.
import { useState, type FormEvent } from 'react';
import { useLogin } from '../api/queries';
import { ApiRequestError } from '../api/client';
import { Button } from '../components/ui';
import './backoffice.css';

export function BackofficeLogin() {
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ email, password });
  };

  return (
    <main className="bo-login">
      <form className="bo-login-card" onSubmit={submit}>
        <label className="bo-login-field">
          <span>E-mail</span>
          <input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </label>
        <label className="bo-login-field">
          <span>Mot de passe</span>
          <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {login.isError ? (
          <p className="bo-login-error" role="alert">
            {login.error instanceof ApiRequestError ? login.error.message : 'Connexion impossible.'}
          </p>
        ) : null}
        <Button type="submit" variant="accent" loading={login.isPending}>
          Se connecter
        </Button>
      </form>
    </main>
  );
}
